import React, { createContext, useContext, useEffect } from 'react';

type Theme = 'light' | 'dark';

interface ThemeContextType {
    theme: Theme;
    toggleTheme: () => void;
    setTheme: (theme: Theme) => void;
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

const THEME_STORAGE_KEY = 'haat_theme_preference';

export const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const theme: Theme = 'light';

    // Force light mode and clear persisted preference.
    useEffect(() => {
        const root = document.documentElement;
        root.classList.remove('dark');
        localStorage.removeItem(THEME_STORAGE_KEY);
    }, []);

    const toggleTheme = () => {
        // Dark mode removed: keep as light-only no-op.
    };

    const setTheme = (_newTheme: Theme) => {
        // Dark mode removed: keep as light-only no-op.
    };

    return (
        <ThemeContext.Provider value={{ theme, toggleTheme, setTheme }}>
            {children}
        </ThemeContext.Provider>
    );
};

export const useTheme = (): ThemeContextType => {
    const context = useContext(ThemeContext);
    if (context === undefined) {
        throw new Error('useTheme must be used within a ThemeProvider');
    }
    return context;
};

export default ThemeContext;
